import { render, staticRenderFns } from "./auth-login.vue?vue&type=template&id=4c870e49&"
import script from "./auth-login.vue?vue&type=script&lang=js&"
export * from "./auth-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports